import { useI18n } from '../lib/i18n';
import { formatRSD } from '../lib/helpers';

function nextNDeadlines(n) {
  const out = [];
  const now = new Date();
  let cursor = new Date(now.getFullYear(), now.getMonth(), 15);
  if (now > cursor) cursor = new Date(now.getFullYear(), now.getMonth() + 1, 15);
  for (let i = 0; i < n; i++) {
    out.push(new Date(cursor));
    cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 15);
  }
  return out;
}

export default function TaxCalendar() {
  const { t, lang } = useI18n();
  const deadlines = nextNDeadlines(12);
  const locale = lang === 'en' ? 'en-GB' : 'sr-Latn-RS';

  return (
    <div>
      <h1 style={styles.heading}>{t('taxCalendarHeading')}</h1>
      <p style={styles.sub}>{t('taxCalendarSub')}</p>

      <div style={styles.list}>
        {deadlines.map((d, i) => {
          const isNext = i === 0;
          const period = new Date(d.getFullYear(), d.getMonth() - 1, 1).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
          return (
            <div key={i} style={{ ...styles.row, ...(isNext ? styles.rowNext : {}) }}>
              <div style={styles.dateBlock}>
                <div style={styles.day}>{d.getDate()}</div>
                <div style={styles.month}>{d.toLocaleDateString(locale, { month: 'short' })}</div>
              </div>
              <div style={styles.rowMain}>
                <div style={styles.rowTitle}>{t('taxRowTitle')}</div>
                <div style={styles.rowSub}>{t('taxRowSub', period)}</div>
              </div>
              {isNext && <span style={styles.badge}>{t('nextDeadlineBadge')}</span>}
            </div>
          );
        })}
      </div>

      <div style={styles.note}>
        {t('taxNote', formatRSD(29428))}
      </div>
    </div>
  );
}

const styles = {
  heading: { fontSize: 22, marginBottom: 8 },
  sub: { fontSize: 13, color: 'var(--ink-500)', marginBottom: 18 },
  list: { display: 'flex', flexDirection: 'column', gap: 8 },
  row: {
    display: 'flex', alignItems: 'center', gap: 16, background: 'var(--surface)', border: '1px solid var(--line)',
    borderRadius: 10, padding: '12px 16px',
  },
  rowNext: { borderColor: 'var(--gold-300)', borderWidth: 1.5 },
  dateBlock: { textAlign: 'center', minWidth: 52, background: 'var(--paper)', border: '1px solid var(--line)', borderRadius: 8, padding: '8px 4px' },
  day: { fontSize: 20, fontWeight: 800, color: 'var(--teal-800)', fontFamily: 'var(--font-display)', lineHeight: 1 },
  month: { fontSize: 11, color: 'var(--ink-500)', textTransform: 'uppercase' },
  rowMain: { flex: 1 },
  rowTitle: { fontWeight: 600, fontSize: 14, color: 'var(--ink-900)' },
  rowSub: { fontSize: 12, color: 'var(--ink-500)' },
  badge: { fontSize: 11, fontWeight: 700, background: 'var(--gold-100)', color: 'var(--gold-600)', borderRadius: 8, padding: '4px 10px', whiteSpace: 'nowrap' },
  note: { marginTop: 20, fontSize: 12, color: 'var(--ink-500)', lineHeight: 1.6 },
};
